import * as Yup from 'yup';

import { FormikErrors } from 'formik';

import { UuidableName } from 'utils/api/types';
import { UserNameResponse } from 'utils/api/modules/user/user.types';

export interface UserJobInformationFormValues {
  jobTitle: string;
  department: string;
  manager: UserNameResponse | null;
  employmentType: string;
  costCentre: string;
  site: UuidableName | null;
  region: string;
  country: string;
  startDate: string | null;
}

export const UserJobInformationSchema = Yup.object().shape({
  jobTitle: Yup.string().max(256, 'Job title is too long'),
  country: Yup.string().max(2),
});

export const mapJobInformationErrors = (
  data: Record<string, unknown> | undefined
): FormikErrors<UserJobInformationFormValues> => {
  const errors: FormikErrors<UserJobInformationFormValues> = {};
  if (!data) {
    return errors;
  }

  const join = (value: unknown): string | undefined => {
    if (Array.isArray(value)) {
      return value.join(' ');
    }
    if (typeof value === 'string') {
      return value;
    }
    return undefined;
  };

  const attributes = data.attributes;
  if (attributes && typeof attributes === 'object') {
    (
      ['jobTitle', 'country', 'startDate', 'department', 'region', 'employmentType', 'site', 'costCentre'] as const
    ).forEach((key) => {
      const message = join((attributes as Record<string, unknown>)[key]);
      if (message) {
        errors[key] = message;
      }
    });
  }

  const managerError = join(data.manager);
  if (managerError) {
    errors.manager = managerError as unknown as FormikErrors<UserJobInformationFormValues>['manager'];
  }

  return errors;
};
